/**
 * The scrapbook's stickers, mirroring `tutor_core::scrapbook::STICKERS` slug
 * for slug and in the same order; `//client:scrapbook_contract_test` holds
 * the two lists to one (kid memory design §3.2). Append-only: the slug is
 * what a page stores, so renaming one blanks every page that has it.
 */
import type { PlainKey } from '../i18n/t.ts';

export const STICKER_SLUGS = [
  'space',
  'animals',
  'food',
  'games',
  'family',
  'colours',
  'school',
  'sports',
  'toys',
  'book',
  'music',
  'weather',
  'birthday',
  'nature',
  'cartoons',
  'chat',
] as const;

export type StickerSlug = (typeof STICKER_SLUGS)[number];

export function isStickerSlug(slug: string): slug is StickerSlug {
  return (STICKER_SLUGS as readonly string[]).includes(slug);
}

export function stickerName(slug: StickerSlug): PlainKey {
  return `scrapbook-sticker-${slug}`;
}
